var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/DynamicFlatListItems.ts";
import * as t from 'io-ts';
import { DynamicBaseGroup, DynamicGeneratedGroup } from './UserClassifierRepo';
export var DynamicGroupFlatItem;

(function (_DynamicGroupFlatItem) {
  var io = _DynamicGroupFlatItem.io = t.recursion('DynamicGroupFlatItem', function () {
    return t.union([DynamicBaseGroup.io, DynamicGeneratedGroup.io]);
  });
})(DynamicGroupFlatItem || (DynamicGroupFlatItem = {}));

export var DynamicGroupFlatItems;

(function (_DynamicGroupFlatItems) {
  var io = _DynamicGroupFlatItems.io = t.recursion('DynamicGroupFlatItems', function () {
    return t.type({
      items: t.array(t.intersection([t.type({
        parentId: t.number,
        parentType: t.union([t.literal('UserClassifierGroupWithGroups'), t.literal('UserClassifierGroupWithElements'), t.literal('DynamicBaseGroup'), t.literal('DynamicGeneratedGroup')])
      }), DynamicGroupFlatItem.io]))
    });
  });
})(DynamicGroupFlatItems || (DynamicGroupFlatItems = {}));